module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-care-journal-devz.web.app/assets/remoteEntry.js?t=1768212494698');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;